import { ref, computed } from "vue";
import he from "he";
export default function useProductVariantSwatches()
{
    function productVariants(variants: string)
    {
        return variants ? JSON.parse(`[${he.decode(variants)}]`) : [];
    }


    function numberOfColors(variants: array)
    {
        const numberOfColors = [...new Set(variants.filter(variant => variant.color != null).map(variant => variant.color))].length;
        return numberOfColors > 1 ? numberOfColors : 0;
    }
    return {
        productVariants,
        numberOfColors
    }
    
}